import { useParams } from 'react-router-dom'
import EditResponseForm from './EditResponseForm'
import { useGetResponseByIdQuery, useGetResponsesQuery } from './responsesApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useGetActionsQuery } from '../actions/actionsApiSlice'
import { useGetTasksQuery } from '../tasks/tasksApiSlice'

const EditResponse = () => {
    useTitle('geshtop-Exercise: Edit Response')

    const { actionId, responseId , taskId } = useParams()
    const { action } = useGetActionsQuery("actionsList", {
        selectFromResult: ({ data }) => ({
            action: data?.entities[actionId]
        }),
    })  
    // const { response } = useGetResponsesQuery("responsesList", {
    //     selectFromResult: ({ data }) => ({
    //         response: data?.entities[responseId]
    //     }),
    // })
    const {
        data: response,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetResponseByIdQuery({id:responseId})

    // const { task } = useGetTasksQuery("tasksList", {
    //     selectFromResult: ({ data }) => ({
    //         task: data?.entities[taskId]
    //     }),
    // })
    if (!response || !action ) return <PulseLoader color={"#FFF"} />

    const content = <EditResponseForm  />

    return content
}
export default EditResponse